import { render, staticRenderFns } from "./WGFilters.vue?vue&type=template&id=08a5a30a&scoped=true&"
import script from "./WGFilters.vue?vue&type=script&lang=js&"
export * from "./WGFilters.vue?vue&type=script&lang=js&"
import style0 from "./WGFilters.vue?vue&type=style&index=0&id=08a5a30a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../tasks/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a5a30a",
  null
  
)

export default component.exports